import React from 'react';
import DirectoryPage from './DirectoryPage';
import { Route, Switch } from 'react-router-dom';

const DirectoryPageWrapper = props => (
    <Switch>
      <Route exact path="/" render={() => <DirectoryPage {...props} />} />
    </Switch>
  );

  export default DirectoryPageWrapper;
